const subscribeNewsletterAlert = (message, type) => {
    $('#subscribeFormAlert').remove();
    $('#subscribeForm').after(
        `<div id="subscribeFormAlert" class="alert alert-${type} d-flex w-auto align-items-center justify-content-center mt-3 mx-auto alert-dismissible" role="alert"><h5 class="body-text m-auto">${message}</h5> <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button></div>`)
}
$(() => {

    let fired = false;
    const siteToken = $('#siteToken').data('token');

    function handleScroll() {

        if (!fired) {
            const recaptchaScript = $('<script>');
            recaptchaScript.attr('src', `https://www.google.com/recaptcha/api.js?render=${siteToken}`);
            recaptchaScript.attr('defer', 'true');
            $('body').append(recaptchaScript);
            fired = true;
            $(window).off('scroll touchstart touchmove mousedown DOMMouseScroll mousewheel keyup click mousemove', handleScroll);
        }
    }
    $(window).on('scroll touchstart touchmove mousedown DOMMouseScroll mousewheel keyup click mousemove', handleScroll);

    const subscribeForm = $('#subscribeForm');
    subscribeForm.submit((e) => {
        e.preventDefault();
        grecaptcha.ready(function () {
            grecaptcha.execute(siteToken, { action: 'submit' }).then(function (token) {
                let actionUrl = subscribeForm.attr('action');
                $.ajax({
                    type: 'POST',
                    url: actionUrl,
                    data: subscribeForm.serialize() + '&token=' + token,
                    beforeSend: (xhr) => {
                        xhr.setRequestHeader('X-WP-Nonce', rest_params.wp_rest);
                    },
                    success: (data) => {
                        subscribeForm[0].reset();
                        subscribeNewsletterAlert(`You've successfully subscribed to the newsletter!`, 'success');
                    },
                    error: (xhr, status, error) => {
                        xhr = JSON.parse(xhr.responseText);
                        subscribeForm[0].reset();
                        subscribeNewsletterAlert(xhr.message, 'warning');
                    }
                });
            });
        });
    });
});
